// extracted by mini-css-extract-plugin
export default {"cell-icon-block":"components-hotel-pricing-assistant-table-cells-td-competitors-rate-module__cell-icon-block"};